export enum EListingTileTagSlug {
  Superhost = 'superhost',
  GuestFavorite = 'guest-favorite',
  MilitaryHost = 'military-host',
  AwardWinner = 'award-winner',
  SignatureFleet = 'signature-fleet',
}
